import React from 'react'
import './sobremi.css'

function Sobremi(){
    return <div className="sobremi">
        <div className="sobremi2">
        <h1>Sobre mí</h1>

        <h2>Desarrollador Salesforce y FullStack</h2>
        <p>Residente de la Ciudad de México, estudié Ingeniería en telecomunicaciones en la facultad de Ingeniería de la UNAM, donde dí mis primeros pasos en desarrollo de software.</p>
        <p>Actualmente laboro como Desarrollador Salesforce y realizando proyectos como Freelance en desarrollo web con el stack MERN (Mongo, Express, React, Node)</p>
        </div>

        </div>
        

    
}

export { Sobremi }